import { render, staticRenderFns } from "./modal-select-project.vue?vue&type=template&id=f1aaea5c&scoped=true"
import script from "./modal-select-project.vue?vue&type=script&lang=js"
export * from "./modal-select-project.vue?vue&type=script&lang=js"
import style0 from "./modal-select-project.vue?vue&type=style&index=0&id=f1aaea5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aaea5c",
  null
  
)

export default component.exports